import { Injectable, inject } from '@angular/core';

import { ClientConfigProductName, ContentService, HtmlNode, ManifestService, Page, StylesService } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

import { StyleOptions } from './loaders.client-config';

/**
 * @experimental
 */
@Injectable({
    providedIn: 'root',
})
export class LoaderStylesService {
    private manifestService = inject(ManifestService);
    private page = inject(Page);
    private stylesService = inject(StylesService);
    private contentService = inject(ContentService);
    private htmlNode = inject(HtmlNode);

    async loadStyles(styles?: StyleOptions[]) {
        if (!styles) {
            return;
        }
        for await (const style of styles) {
            if (style.htmlCssClass) {
                this.htmlNode.setCssClass(style.htmlCssClass, true);
            }
            switch (style.type) {
                case 'url':
                    await this.stylesService.loadStyle({ url: style.id, lazyLoad: 2 });
                    break;
                case 'theme':
                    let filename = this.getNewThemeFilename(style.id);
                    let themesCssPath = this.manifestService.getEntry(filename);
                    if (!themesCssPath) {
                        filename = this.getThemeFileNameFallback(style.id);
                        themesCssPath = this.manifestService.getEntry(filename);
                    }
                    if (themesCssPath) {
                        await this.stylesService.loadStyle({ url: themesCssPath, lazyLoad: 2 });
                    }
                    break;
                case 'content':
                    const path = `App-v1.0/LazyStyles/${style.id}`;
                    const file = await firstValueFrom(this.contentService.getJson(path, { product: ClientConfigProductName.SF }));
                    await this.stylesService.addStyle(style.id, file.content);
                    break;
            }
        }
    }

    private getNewThemeFilename(entry: string) {
        return `${this.page.theme}/themes-${this.page.theme}-${entry}.css`;
    }

    //this is the default format for all applications styles, before removing, please ensure correct product's style mapped in the manifest.
    private getThemeFileNameFallback(entry: string) {
        return `themes-${this.page.theme}-${entry}.css`;
    }
}
